import type {
  ApiResponse,
  AuditLog,
  PaginationMeta,
  PaymentProvider,
  PaymentProviderStatus,
  StoreGatewayCredentialStatus,
} from '@giftsay/types';

import { apiClient } from '../../../lib/axios.js';

export async function getPaymentProviders(): Promise<PaymentProviderStatus[]> {
  const { data } = await apiClient.get<ApiResponse<PaymentProviderStatus[]>>('/payment-providers');
  return data.data ?? [];
}

export interface ListAuditLogsParams {
  cursor?: string;
  pageSize?: number;
  storeId?: string;
  provider?: PaymentProvider | 'manual' | '';
}

export interface ListAuditLogsResult {
  items: AuditLog[];
  meta: PaginationMeta;
}

export async function listAuditLogs(params: ListAuditLogsParams): Promise<ListAuditLogsResult> {
  const { data } = await apiClient.get<ApiResponse<AuditLog[]>>('/audit-logs', {
    params: {
      ...params,
      storeId: params.storeId || undefined,
      provider: params.provider || undefined,
    },
  });
  return { items: data.data ?? [], meta: data.meta as PaginationMeta };
}

export type SaveStoreCredentialsPayload =
  | { provider: 'razorpay'; keyId: string; keySecret: string; webhookSecret: string | null }
  | {
      provider: 'cashfree';
      clientId: string;
      clientSecret: string;
      environment: 'sandbox' | 'production';
    };

export async function getStoreCredentials(
  storeId: string,
): Promise<StoreGatewayCredentialStatus[]> {
  const { data } = await apiClient.get<ApiResponse<StoreGatewayCredentialStatus[]>>(
    `/stores/${storeId}/payment-credentials`,
  );
  return data.data ?? [];
}

export async function saveStoreCredentials(
  storeId: string,
  payload: SaveStoreCredentialsPayload,
): Promise<StoreGatewayCredentialStatus[]> {
  const { data } = await apiClient.patch<ApiResponse<StoreGatewayCredentialStatus[]>>(
    `/stores/${storeId}/payment-credentials`,
    payload,
  );
  return data.data ?? [];
}

export async function removeStoreCredentials(
  storeId: string,
  provider: PaymentProvider,
): Promise<StoreGatewayCredentialStatus[]> {
  const { data } = await apiClient.delete<ApiResponse<StoreGatewayCredentialStatus[]>>(
    `/stores/${storeId}/payment-credentials/${provider}`,
  );
  return data.data ?? [];
}
